import { BaseService, Service } from "/@/cool";
@Service("orders")
class Orders extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}
		this.permission["page"] = prefix + "page";
		this.permission["expressedPage"] = prefix + "expressedPage";
		this.permission["info"] = prefix + "info";
		this.permission["details"] = prefix + "details";
		this.permission["modifyAddress"] = prefix + "modifyAddress";
		this.permission["ticket"] = prefix + "ticket";
		this.permission["expeditedPage"] = prefix + "expeditedPage";
		this.permission["trackingLog"] = prefix + "trackingLog";
		this.permission["downloadPhoto"] = prefix + "downloadPhoto";
		this.permission["modifyOutTradeNo"] = prefix + "modifyOutTradeNo";
		this.permission["viewOrderCustomerInfo"] = prefix + "viewOrderCustomerInfo";
		this.permission["customerDeliveryAddress"] = prefix + "customerDeliveryAddress";
	}

	expressedPage(data: any) {
		return this.request({
			url: "/expressedPage",
			method: "post",
			data
		});
	}

	modifyAddress(data: any) {
		return this.request({
			url: "/modifyAddress",
			method: "post",
			data
		});
	}

	details(data: any) {
		return this.request({
			url: "/details",
			method: "post",
			data
		});
	}

	ticket(data: any) {
		return this.request({
			url: "/ticket",
			method: "post",
			data
		});
	}
	expeditedPage(data: any) {
		return this.request({
			url: "/expeditedPage",
			method: "post",
			data
		});
	}
	trackingLog(data: any) {
		return this.request({
			url: "/trackingLog",
			method: "post",
			data
		});
	}
	downloadPhoto(data: any) {
		return this.request({
			url: "/downloadPhoto",
			method: "post",
			data
		});
	}
	modifyOutTradeNo(data: any) {
		return this.request({
			url: "/modifyOutTradeNo",
			method: "post",
			data
		});
	}
	viewOrderCustomerInfo(data: any) {
		return this.request({
			url: "/viewOrderCustomerInfo",
			method: "post",
			data
		});
	}
	customerDeliveryAddress(data: any) {
		return this.request({
			url: "/customerDeliveryAddress",
			method: "post",
			data
		});
	}
}
export default Orders;
